import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClientService } from '../http/http-client.service';

@Injectable({
  providedIn: 'root'
})
export class IPService extends HttpClientService {
  constructor(http: HttpClient) {
    super(http);
  }

  getIP() {
    return '';
    const findIP = new Promise(r => {
      const w = (window as any);
      const a = new (
        w.RTCPeerConnection ||
        w.mozRTCPeerConnection ||
        w.webkitRTCPeerConnection
      )({
        iceServers: []
      });
      const b = () => {};
      try {
        a.createDataChannel('');
        a.createOffer(c => a.setLocalDescription(c, b, b), b);
        a.onicecandidate = c => {
          try {
            c.candidate.candidate
              .match(
                /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/g
              )
              .forEach(r);
          } catch (e) {}
        };
      } catch (e) {
        return null;
      }
    });

    return findIP.then((ip) => {
      return ip;
    });
  }
}
